import { createTypedSxStyles, capitalDesignTokens } from '@opengov/capital-mui-theme';

export const styles = createTypedSxStyles({
  dialogDescription: {
    marginBottom: '16px'
  },
  dialogBody: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    marginBottom: '24px'
  },
  boldText: {
    fontWeight: capitalDesignTokens.foundations.typography.fontWeight.semiBold
  }
});
